import styled, { keyframes } from 'styled-components';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import colors from '../../../styles/colors';
import { device } from '../../../styles/media';

const hoverOn = keyframes`
    from {
        width: 3rem;
        height: 3rem;
    }
    to {
        height: 100%;
        width: 100%;
    }
  `

const hoverOff = keyframes`
  from {
      width: 100%;
      height: 100%;
  }
  to {
      height: 3rem;
      width: 3rem;
  }
`

export const StyledContainer = styled(Container)`
    height: 600px;
    text-align: center;
    width: 100vw;
    color: ${colors.textDark};

    @media ${device.tablet}{
        height: 950px;
    }
    @media ${device.mobile}{
        height: 1770px;
    }
    @media ${device.xs}{
        height: 1810px;
    }
`

export const StyledGrid = styled(Grid)`
    height: 360px;
`

export const StyledGridItem = styled(Grid)`
    height: 400px;
    max-width: 300px;
`

export const StyledH2 = styled.h2`
    font-size: 2.5rem;
    padding-bottom: 30px;
    font-weight: 400;

    @media ${device.tablet}{
        padding-bottom: 0;
        margin-top: 1rem;
    }
`

export const StyledImg = styled.img`
    width: 100%;
    max-width: 300px;
    height: 69.5%;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
`
export const StyledOverLay = styled.div`
    border-bottom-left-radius: 5px;
    height: 3rem;
    width: 3rem;
    position: absolute;
    bottom: 0;
    background-color: ${colors.secondary};

    animation: ${hoverOff} 0.15s ease-out;

    &:hover{
        animation: ${hoverOn} 0.15s;
        animation-fill-mode: forwards; 
        animation-play-state: ease-in;
    }
    &:hover .hidden{
        display: block;
    }
    &:hover .icon {
        display: none;
    }
`

export const StyledP = styled.p`
    margin-top: 1.0rem;
    font-weight: 700;
    font-size: 1.3rem;
    color: ${colors.secondary};
`

export const StyledPaper = styled(Paper)`
    height: 100%;
`

export const StyledSpan = styled.span`
    color: ${colors.textMedium}
`
export const TextWrapper = styled.div`
    height: 30%;
    position: relative;
`

export const StyledText = styled.div`
    margin: 0;
    color: ${colors.textDark};
`

export const StyledIcon = styled(FontAwesomeIcon)`
    color: white;
    padding-top: 1rem;
`

export const StyledFact = styled.p`
    color: white;
    display: none;
    padding-top: 2rem;
`
